$('.copyrightYear').text(new Date().getFullYear());